import { trimAndLimitProfileText } from "./profileText";
import { normalizeProfileDisplayName } from "./profileName";

// The minimal set of profile fields the edit form is allowed to write.
// Deliberately excludes profileImage (owned by the avatar flow) and every
// server-managed field (lastActive, notificationPreferences, fcmTokens, …) so a
// stale store profile can never clobber them when the user saves.
export function buildProfileEditPayload(formData = {}) {
  return {
    userName: trimAndLimitProfileText(formData.userName),
    displayName: normalizeProfileDisplayName(formData.displayName),
    publicHandle: trimAndLimitProfileText(formData.publicHandle),
    bio: formData.bio ?? "",
    affiliatedRewards: Array.isArray(formData.affiliatedRewards) ? formData.affiliatedRewards : [],
    email: formData.email ?? "",
    phoneNumber: formData.phoneNumber ?? "",
  };
}

export default buildProfileEditPayload;
